import styled from "styled-components";

const SearchWrapper = styled.div`
  position: relative;
  text-align: center;
  border-radius: 8px;
  height: 2.250rem;
  width: 90%;
  min-width: 328px;
  margin: 4px 12px;
  background-color: #f1f3f5;


  img {
    max-width: 20px;
    position: absolute;
    top: 8px;
    left: 12px;
  }

  p {
    position: absolute;
    top: 6px;
    left: 44px;
    color: #4A5056;
    font-size: 1rem;
  }
`;

export { SearchWrapper };